import { useMemo } from "react";
import { useSelector } from "react-redux";
import { dualStreamEnabled } from "../shared/utility";
import { isEmpty } from "lodash";

const useCheckCallConnected = () => {
    const { isRemoteParticipantJoined, expandView } = useSelector((state) => state.commonReducer);
    const { isAnyVideoAvailableInTheRoom, screenSharingUsers, videoStreamingUsers } = useSelector((state) => state.twilioEvents);

    const isButtonDisable = useMemo(() => {
        if (dualStreamEnabled() && !expandView) {
            return true;
        }
        return !(isRemoteParticipantJoined && (!isEmpty(videoStreamingUsers) || screenSharingUsers?.length > 0));
    }, [isRemoteParticipantJoined, isAnyVideoAvailableInTheRoom, expandView, screenSharingUsers, videoStreamingUsers]);

    return isButtonDisable;
};

export default useCheckCallConnected;
